document.addEventListener("DOMContentLoaded", () => {
    const editPost = document.querySelector("#morePostActions .edit");
    const deletePost = document.querySelector("#morePostActions .delete");
    const reportPost = document.querySelector("#morePostActions .report");


    // if (editPost) {
    //     editPost.addEventListener("click", devtricker_post_edit_redirectToEditPage);
    // }

    if (deletePost) {
        deletePost.addEventListener("click", devtricker_devtricker_confirmPostDeletionRedirectHome);
    }

    const authorId = devtricker_getAuthorIdFromMeta();
    const loggedUserId = devtricker_getTheLoggedUserId();

    if (loggedUserId == authorId) {
        if (reportPost) {
            reportPost.classList.add("d-none");
        }
    } else {
        if (editPost) {
            editPost.classList.add("d-none");
        }

        if (deletePost) {
            deletePost.classList.add("d-none");
        }
    }
});